'use client';

import { useState, useRef, useLayoutEffect } from 'react';
import { motion, animate, AnimationPlaybackControls, AnimatePresence } from 'framer-motion';
import FingerIcon from '@/app/components/icons/FingerIcon';

export default function HorizontallyScrollableSection({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const [isScrollable, setIsScrollable] = useState(false);
  const [userHasInteracted, setUserHasInteracted] = useState(false);
  const scrollableContainerRef = useRef<HTMLDivElement>(null);
  // const animationControlsRef = useRef<AnimationPlaybackControls | null>(null);

  useLayoutEffect(() => {
    const container = scrollableContainerRef.current;
    if (!container)
    {
      return;
    }

    const checkScrollable = () => {
      const hasOverflow = container.scrollWidth > container.clientWidth;
      setIsScrollable(hasOverflow);
    };

    checkScrollable();
    window.addEventListener('resize', checkScrollable);


    if (isScrollable && !userHasInteracted)
    {

      // animationControlsRef.current = animate(container.scrollLeft, 180,
      //   {
      //     // duration: 0.3,
      //     // type: 'tween',
      //     ease: [.88, .19, .34, .78],
      //     duration: 0.6,
      //     type: 'spring',
      //     // stiffness: 140,
      //     damping: 30,
      //     repeat: Infinity,
      //     repeatType: 'reverse',
      //     repeatDelay: 0.5,
      //     onUpdate: (latest) => {
      //
      //       if (container)
      //       {
      //         container.scrollLeft = latest;
      //       }
      //     },
      //   });
    }

    return () => {
      window.removeEventListener('resize', checkScrollable);

      // animationControlsRef.current?.stop();
    };
  }, [isScrollable, userHasInteracted]);


  const handleUserInteraction = () => {

    // animationControlsRef.current?.stop();
    if (!userHasInteracted)
    {
      setUserHasInteracted(true);
    }
  };

  return (
    <div className={ 'grid grid-rows-1 grid-cols-1 items-center justify-center' }>
      <motion.div
        ref={ scrollableContainerRef }
        className={ `col-start-1 col-end-2 row-start-1 row-end-2 overflow-x-auto order-1 overflow-y-hidden flex flex-row ${ className }` }
        // onPointerDown={ handleUserInteraction }
        // onWheel={ handleUserInteraction }
        onScroll={ handleUserInteraction }
      >
        { children }
      </motion.div>
      <AnimatePresence initial={ true }>
        { !userHasInteracted &&
          <motion.div exit={ { opacity: 0, scale: 0 } } className={ 'order-2 col-start-1 col-end-2 row-start-1 row-end-2 pr-4 block md:hidden pointer-events-none z-20' }>
            <div className={ 'w-full flex flex-row justify-end items-center' }>
              <FingerIcon className={ 'fill-white  size-16 -mr-2' } />
              <motion.div className={ 'flex flex-col gap-1.5' }
                          initial={ { width: 0 } }
                          animate={ { width: '80%' } }
                          transition={ { duration: 0.6, type: 'spring', damping: 30, stiffness: 140, repeat: Infinity, repeatType: 'reverse', repeatDelay: 0.5 } }>
                {/*<div className={ 'h-0.5 w-full bg-white/30 rounded-md' }></div>*/ }
                {/*<div className={ 'h-[3px] w-full bg-white/30 rounded-md' }></div>*/ }
                {/*<div className={ 'h-0.5 w-full bg-white/30 rounded-md' }></div>*/ }
              </motion.div>
            </div>
          </motion.div> }
      </AnimatePresence>
    </div>
  );
}
